Object.defineProperty(exports,"__esModule",{value:true});var _reduxOrm=require('redux-orm');
var _Fixture=require('./Fixture');var _Fixture2=_interopRequireDefault(_Fixture);
var _Position=require('./Position');var _Position2=_interopRequireDefault(_Position);
var _SecurityDevice=require('./SecurityDevice');var _SecurityDevice2=_interopRequireDefault(_SecurityDevice);
var _Store=require('./Store');var _Store2=_interopRequireDefault(_Store);
var _SecuredProduct=require('./SecuredProduct');var _SecuredProduct2=_interopRequireDefault(_SecuredProduct);
var _StoreAddress=require('./StoreAddress');var _StoreAddress2=_interopRequireDefault(_StoreAddress);
var _Area=require('./Area');var _Area2=_interopRequireDefault(_Area);
var _Floor=require('./Floor');var _Floor2=_interopRequireDefault(_Floor);
var _AreaLayoutPosition=require('./AreaLayoutPosition');var _AreaLayoutPosition2=_interopRequireDefault(_AreaLayoutPosition);
var _FixtureLayoutPosition=require('./FixtureLayoutPosition');var _FixtureLayoutPosition2=_interopRequireDefault(_FixtureLayoutPosition);
var _PositionLayoutPosition=require('./PositionLayoutPosition');var _PositionLayoutPosition2=_interopRequireDefault(_PositionLayoutPosition);
var _LayoutPosition=require('./LayoutPosition');var _LayoutPosition2=_interopRequireDefault(_LayoutPosition);
var _PositionRule=require('./PositionRule');var _PositionRule2=_interopRequireDefault(_PositionRule);
var _FixtureRule=require('./FixtureRule');var _FixtureRule2=_interopRequireDefault(_FixtureRule);
var _StoreRule=require('./StoreRule');var _StoreRule2=_interopRequireDefault(_StoreRule);
var _Manufacturer=require('./Manufacturer');var _Manufacturer2=_interopRequireDefault(_Manufacturer);
var _Product=require('./Product');var _Product2=_interopRequireDefault(_Product);
var _Organization=require('./Organization');var _Organization2=_interopRequireDefault(_Organization);
var _Rule=require('./Rule');var _Rule2=_interopRequireDefault(_Rule);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var orm=new _reduxOrm.ORM();
orm.register(
_Fixture2.default,
_Position2.default,
_SecurityDevice2.default,
_Store2.default,
_SecuredProduct2.default,
_StoreAddress2.default,
_Area2.default,
_Floor2.default,
_AreaLayoutPosition2.default,
_FixtureLayoutPosition2.default,
_PositionLayoutPosition2.default,
_LayoutPosition2.default,
_PositionRule2.default,
_FixtureRule2.default,
_StoreRule2.default,
_Manufacturer2.default,
_Product2.default,
_Organization2.default,
_Rule2.default);exports.default=


orm;